export default __webpack_public_path__ + "static/media/pammContentIcon3.cd6db277.webp";